// extracted by mini-css-extract-plugin
export var loader = "CruiseResults-module--loader--2K0qY";
export var loaderCruise = "CruiseResults-module--loaderCruise--tx-MN";